function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M11.4,80.1V12.4H18v67.7H11.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M37.3,65.9c1.1,2.2,2.8,3.9,5,5.3c2.3,1.3,4.8,2,7.7,2c2.5,0,4.8-0.5,6.7-1.5c1.9-1,3.4-2.4,4.3-4.2 c0.9-1.8,1.4-3.7,1.4-5.8c0-2.1-0.5-4-1.4-5.6c-0.9-1.6-2.4-2.9-4.5-4c-1.3-0.7-4.3-1.8-8.9-3.3s-7.8-2.9-9.7-4.2 c-2.4-1.7-4.2-3.8-5.4-6.3c-1.2-2.5-1.8-5.3-1.8-8.4c0-3.4,0.7-6.6,2.2-9.6c1.4-3,3.5-5.2,6.3-6.8c2.8-1.5,5.8-2.3,9.2-2.3 c3.7,0,7,0.8,9.8,2.4c2.8,1.6,4.4,3.7,6,6.8l-6.8,1.9c-2-2.2-4.9-3.3-8.7-3.3c-4,0-6.9,1-8.8,3c-1.8,2-2.8,4.4-2.8,7.2 c0,2.4,0.6,4.4,1.9,6c1.3,1.6,4.6,3.2,10,4.8c5.4,1.6,9.1,3.1,11.1,4.3c2.9,1.8,5.1,4.1,6.5,6.9c1.4,2.8,2.1,6,2.1,9.6 c0,3.6-0.8,7-2.3,10.2c-1.5,3.2-3.7,5.7-6.6,7.4c-2.9,1.8-6.1,2.7-9.7,2.7c-4.5,0-8.3-0.9-11.4-2.7c-3.1-1.8-5.5-4.5-7.2-8.1 L37.3,65.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M78.9,47.1c0-11.2,2.9-20,8.8-26.4c5.9-6.4,13.5-9.5,22.8-9.5c6.1,0,11.6,1.5,16.5,4.5s8.6,7.1,11.2,12.5 c2.6,5.3,3.9,11.4,3.9,18.2c0,6.9-1.4,13-4.1,18.4c-2.7,5.4-6.5,9.5-11.5,12.3c-5,2.8-10.3,4.2-16,4.2c-6.2,0-11.8-1.5-16.7-4.6 C89,73.5,85.2,69.3,82.7,64C80.2,58.7,78.9,53,78.9,47.1z M87.9,47.2c0,8.2,2.1,14.6,6.4,19.3s9.6,7,16.1,7c6.6,0,12-2.4,16.2-7.1 c4.2-4.7,6.4-11.5,6.4-20.2c0-5.5-0.9-10.3-2.7-14.4c-1.8-4.1-4.5-7.3-8-9.6c-3.5-2.3-7.4-3.4-11.8-3.4c-6.2,0-11.5,2.2-16,6.5 C90.2,29.8,87.9,37,87.9,47.2z"
}));

var SvgIsoIcon = function SvgIsoIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 96.1",
    style: {
      enableBackground: "new 0 0 150 96.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIsoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iso-icon.31ad87b6.svg";
export { ForwardRef as ReactComponent };